import { useMemo } from 'react';
import { useHasFF } from 'venn-utils';
import { refreshHelpCenterLinks } from './index';

/**
 * Keeps the help center links in sync with venn_help_on_riskpro_ff, whose value is unknown until the feature flag map
 * loads. Call this from a component mounted above the app content: resolving during render rather than in an effect
 * means descendants read the resolved links in the same commit.
 */
export const useSyncHelpCenterLinks = () => {
  const servesVennHelpCenter = useHasFF('venn_help_on_riskpro_ff');
  useMemo(refreshHelpCenterLinks, [servesVennHelpCenter]);
};
